// extracted by mini-css-extract-plugin
export default {"bg":"GenralInsurance_bg__qaDE4","container":"GenralInsurance_container__Zuk8g","left":"GenralInsurance_left__u5gjE","right":"GenralInsurance_right__hAvsB"};